import { useTranslation } from "react-i18next";
import { I18N_NAMESPACE } from "./constants";
export const useTranslationSSR = useTranslation.bind(this, I18N_NAMESPACE, { useSuspense: false });
export { useTranslation, withTranslation, I18nextProvider, Trans } from "react-i18next";
export { initI18n } from "./initializeI18n";
export { defineMessages } from "./defineMessages";
//# sourceMappingURL=index.js.map